import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#555",
      "fill-rule": "evenodd",
      d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0m0 1.188a5.813 5.813 0 0 0 0 11.625A5.813 5.813 0 0 0 7 1.188m0 8.625a.625.625 0 1 1 0 1.25.625.625 0 0 1 0-1.25m0-6.5c.656 0 1.275.224 1.744.635.487.427.756 1 .754 1.615 0 .903-.595 1.715-1.517 2.07a.755.755 0 0 0-.483.7v.354a.125.125 0 0 1-.125.126h-.75a.125.125 0 0 1-.125-.126v-.335a1.746 1.746 0 0 1 1.125-1.653c.533-.205.877-.65.877-1.136 0-.69-.673-1.25-1.5-1.25s-1.5.56-1.5 1.25v.118a.125.125 0 0 1-.125.125h-.75a.125.125 0 0 1-.125-.125v-.119c0-.614.269-1.187.756-1.614A2.64 2.64 0 0 1 7 3.313"
    }, null, -1)
  ])))
}
export default { render: render }